export const MOVEMENT_PREVIEW_SIZE = 3;
export const CUSTOMER_HISTORY_PAGE_SIZE = 20;
